import React from 'react';

const PlusCircleIcon = ({ classes, onClick, extraClass }) => (
    <svg className={`svg-icon plus-circle-icon ${classes}`} width="20px" height="20px" viewBox="10 10 20 20"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={onClick}>
        <g className={`theme-path ${extraClass}`} fillRule="evenodd" transform="translate(0.000000, 0.000000)">
            <path d="M19,19 L19,16 L21,16 L21,19 L24,19 L24,21 L21,21 L21,24 L19,24 L19,21 L16,21 L16,19 L19,19 Z M20,
            10 C25.5228475,10 30,14.4771525 30,20 C30,25.5228475 25.5228475,30 20,30 C14.4771525,30 10,25.5228475 10,
            20 C10,14.4771525 14.4771525,10 20,10 Z M20,12 C15.581722,12 12,15.581722 12,20 C12,24.418278 15.581722,
            28 20,28 C24.418278,28 28,24.418278 28,20 C28,15.581722 24.418278,12 20,12 Z">
            </path>
        </g>
    </svg>
);

export default PlusCircleIcon;
